import { withAuthenticationRequired } from '@auth0/auth0-react';
import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Intro from '@app/layout/Intro.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import AiDispatcherActivityPage from '@app/pages/settings/AiDispatcherActivityPage.tsx';

const AiDispatcherActivityRoute = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout
      title={tr('AiDispatcher.activityPageTitle', 'AI dispatcher activity')}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_AI_DISPATCHER_READ, PermissionTypesEnum.PERMISSION_AI_DISPATCHER_RW]}
    >
      <AiDispatcherActivityPage />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(AiDispatcherActivityRoute, {
  onRedirecting: () => <Intro />,
});
